import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusBadge, fmtDateTime } from "@/components/common";
import DataTable from "@/components/DataTable";
import AdvancedFilters from "@/components/AdvancedFilters";
import QuickFilters from "@/components/QuickFilters";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { toast } from "sonner";

const QF = [{ key: "type", label: "Types" }, { key: "owner_name", label: "Owners" }, { key: "priority", label: "Priorities" }, { key: "status", label: "Statuses" }, { key: "course", label: "Courses", get: (r) => (r.course || "").split(", ") }, { key: "colleges", label: "Colleges" }, { key: "last_disposition", label: "Last Dispositions" }];

export default function Tasks() {
  const [rows, setRows] = useState(null);
  const [quick, setQuick] = useState(null);
  const [display, setDisplay] = useState(null);
  const load = () => api.get("/tasks").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);
  const complete = async (id) => { await api.patch(`/tasks/${id}`, { status: "Completed" }); toast.success("Task completed"); load(); };
  const FIELDS = useMemo(() => [
    { key: "title", label: "Task", type: "text" }, { key: "student_name", label: "Lead / Candidate", type: "text" },
    { key: "type", label: "Type", type: "text" }, { key: "owner_name", label: "Owner", type: "text" },
    { key: "priority", label: "Priority", type: "select", options: ["High", "Normal", "Low"] }, { key: "status", label: "Status", type: "text" },
    { key: "due_at", label: "Due", type: "date" },
  ], []);
  const columns = [
    { key: "title", label: "Task", fixed: true, render: (r) => <span className="font-medium text-slate-800">{r.title}</span> },
    { key: "student_name", label: "Lead / Candidate", render: (r) => <span className="font-semibold text-[#312E81]" data-testid="task-candidate-name">{r.student_name || "—"}</span> },
    { key: "type", label: "Type", render: (r) => <StatusBadge value={r.type} /> },
    { key: "owner_name", label: "Owner" },
    { key: "priority", label: "Priority", render: (r) => <StatusBadge value={r.priority} /> },
    { key: "due_at", label: "Due", render: (r) => <span className="text-xs">{fmtDateTime(r.due_at)}</span> },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "created_at", label: "Created On", hidden: true, render: (r) => <span className="text-xs">{fmtDateTime(r.created_at)}</span> },
    { key: "a", label: "", fixed: true, render: (r) => r.status !== "Completed" && <Button size="sm" variant="outline" className="h-7 px-2" onClick={() => complete(r.id)} data-testid={`task-complete-${r.id}`}><Check className="w-3.5 h-3.5" /></Button> },
  ];
  return (
    <div>
      <PageHeader title="Tasks" subtitle="Your action items" testid="tasks-header" />
      <QuickFilters rows={rows} fields={QF} onFiltered={setQuick} testid="tasks" />
      <AdvancedFilters entity="tasks" fields={FIELDS} rows={quick} onFiltered={setDisplay} />
      <DataTable columns={columns} rows={display} loading={rows === null} testid="tasks-table" columnsKey="tasks" />
    </div>
  );
}
